import { makeContextModule } from '@cian/react-utils';

import {
  IOffersHistoryState,
  TCategoriesFilterActiveValue,
  TCategoriesFilterOptionValue,
  TRoomsFilterOptionValue,
  TStatusFilterOptionValue,
} from '../types';

interface IOfferFromHistoryParams {
  cianId?: number;
  isDesktop?: boolean;
}

interface IRequestAuthenticationParams {
  onSuccess?: VoidFunction;
}

export interface IOffersHistoryContext extends IOffersHistoryState {
  getOffersHistory: (isLoadMore?: boolean) => void;
  changeFilters: (isChanged: boolean) => void;
  resetAllFilters: VoidFunction;
  onRoomsFilterChange: (value: TRoomsFilterOptionValue) => void;
  onStatusFilterChange: (value: TStatusFilterOptionValue) => void;
  onCategoriesFilterChange: (value: TCategoriesFilterOptionValue) => void;
  onShowMoreButtonClick: VoidFunction;
  resetActiveOffer: VoidFunction;
  setCategoriesFilter: (value: TCategoriesFilterActiveValue) => void;
  onFullscreenButtonClick: () => void;
  openOfferFromHistory: (params?: IOfferFromHistoryParams) => void;
  getOfferFromHistory: (params: IOfferFromHistoryParams) => void;
  requestAuthentication: (callbacks: IRequestAuthenticationParams) => void;
  setViewedOffer: (offerId: number) => void;
  onOfferLinkClick: VoidFunction;
}

export const { Context: OffersHistoryContext, useContext: useOffersHistoryContext } =
  makeContextModule<IOffersHistoryContext>({
    contextName: 'OffersHistoryContext',
  });
